import { useEffect, useRef } from "react";

const useDidMountEffect = (fn: () => any, deps: any[]) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) return fn();
    else didMount.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useDidMountEffect;
